import { getAdjustedTime } from '@/lib/timeUtils'

export function formatScheduledTime(
	utcString: string,
	locale?: string,
	todayLabel = 'Today',
	timeZoneOffset?: number,
	tomorrowLabel = 'Tomorrow',
): string {
	const raw = new Date(utcString)
	if (isNaN(raw.getTime())) return utcString

	const date = timeZoneOffset !== undefined ? getAdjustedTime(timeZoneOffset, raw) : raw
	const now = timeZoneOffset !== undefined ? getAdjustedTime(timeZoneOffset) : new Date()

	const isSameCalendarDay = (a: Date, b: Date) =>
		a.getFullYear() === b.getFullYear() &&
		a.getMonth() === b.getMonth() &&
		a.getDate() === b.getDate()

	const tomorrow = new Date(now)
	tomorrow.setDate(tomorrow.getDate() + 1)

	const timeStr = date.toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit' })

	if (isSameCalendarDay(date, now)) return `${todayLabel} at ${timeStr}`
	if (isSameCalendarDay(date, tomorrow)) return `${tomorrowLabel} at ${timeStr}`
	return timeStr
}
